module.exports = __webpack_public_path__ + "static/media/RMPLogo.837ed4cc.png";